import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject, Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { Unit } from 'src/app/units/models/unit';
import { UnitService } from 'src/app/units/services/unit.service';

export interface EyeStateEvent {
  imeis: string[];
  show: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class VehicleEyeStateService {
  private eyeStateSubject = new Subject<EyeStateEvent>();
  eyeState$ = this.eyeStateSubject.asObservable();
  private globalEyeState = new BehaviorSubject<boolean>(true);
  globalEyeState$ = this.globalEyeState.asObservable();
  private vehicles$ = new Observable<string[]>();

  // Nuevo: Mantener el estado de visibilidad de cada vehículo
  private vehicleStates = new Map<string, boolean>();
  private vehicleStatesSubject = new BehaviorSubject<Map<string, boolean>>(
    new Map()
  );
  vehicleStates$ = this.vehicleStatesSubject.asObservable();

  constructor(private unitService: UnitService) {
    this.vehicles$ = this.unitService.getUnits.pipe(
      map((units: Unit[]) => units.map((unit) => unit.device.IMEI.toString()))
    );
  }

  // Actualizar estado individual
  updateVehicleState(imei: string, isVisible: boolean) {
    this.vehicleStates.set(imei, isVisible);
    this.vehicleStatesSubject.next(this.vehicleStates);
  }

  // Obtener estado actual
  getVehicleState(imei: string): boolean {
    return this.vehicleStates.has(imei)
      ? !this.vehicleStates.get(imei)!
      : false;
  }

  // Modificar para considerar estados actuales
  toggleVehiclesVisibility(imeis: string[], show: boolean) {
    // Actualizar estados
    imeis.forEach((imei) => this.updateVehicleState(imei, show));
    this.emitEyeStateChange(imeis, show);
  }

  emitEyeStateChange(imeis: string[], show: boolean) {
    this.eyeStateSubject.next({ imeis, show });
  }

  updateGlobalEyeState(isVisible: boolean) {
    this.globalEyeState.next(isVisible);
    this.vehicles$.pipe(take(1)).subscribe({
      next: (IMEIs: string[]) => {
        IMEIs.forEach((IMEI) => this.vehicleStates.set(IMEI, isVisible));
        this.vehicleStatesSubject.next(new Map(this.vehicleStates));
        this.emitEyeStateChange(IMEIs, isVisible);
      },
    });
  }

  getGlobalEyeState(): boolean {
    return this.globalEyeState.getValue();
  }
}
